"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewPosition = void 0;
const ViewPositionControls_1 = require("./components/ViewPositionControls");
class ViewPosition {
    constructor(webgl) {
        this.setPositionFunctions = {
            left: () => this.setPosition(3 /* LEFT */),
            right: () => this.setPosition(4 /* RIGHT */),
            top: () => this.setPosition(5 /* TOP */),
            bottom: () => this.setPosition(6 /* BOTTOM */),
            front: () => this.setPosition(1 /* FRONT */),
            back: () => this.setPosition(2 /* BACK */),
            center: () => PubSub.publish("initial-position-goto" /* INITIAL_POSITION_GOTO */)
        };
        this.webgl = webgl;
        const parentEl = document.getElementById('viewPosition');
        if (!parentEl) {
            throw new Error("Parent element (viewPosition) is undefined");
        }
        this.viewPositionControls = new ViewPositionControls_1.ViewPositionControls(parentEl);
        this.addEvents();
    }
    dispose() {
        var _a;
        this.removeEvents();
        (_a = this.viewPositionControls) === null || _a === void 0 ? void 0 : _a.dispose();
        delete this.viewPositionControls;
        delete this.webgl;
    }
    addEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        (_b = (_a = this.viewPositionControls) === null || _a === void 0 ? void 0 : _a.leftBtn) === null || _b === void 0 ? void 0 : _b.setEvent('click', this.setPositionFunctions.left);
        (_d = (_c = this.viewPositionControls) === null || _c === void 0 ? void 0 : _c.rightBtn) === null || _d === void 0 ? void 0 : _d.setEvent('click', this.setPositionFunctions.right);
        (_f = (_e = this.viewPositionControls) === null || _e === void 0 ? void 0 : _e.topBtn) === null || _f === void 0 ? void 0 : _f.setEvent('click', this.setPositionFunctions.top);
        (_h = (_g = this.viewPositionControls) === null || _g === void 0 ? void 0 : _g.bottomBtn) === null || _h === void 0 ? void 0 : _h.setEvent('click', this.setPositionFunctions.bottom);
        (_k = (_j = this.viewPositionControls) === null || _j === void 0 ? void 0 : _j.frontBtn) === null || _k === void 0 ? void 0 : _k.setEvent('click', this.setPositionFunctions.front);
        (_m = (_l = this.viewPositionControls) === null || _l === void 0 ? void 0 : _l.backBtn) === null || _m === void 0 ? void 0 : _m.setEvent('click', this.setPositionFunctions.back);
        (_p = (_o = this.viewPositionControls) === null || _o === void 0 ? void 0 : _o.centerBtn) === null || _p === void 0 ? void 0 : _p.setEvent('click', this.setPositionFunctions.center);
    }
    removeEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        (_b = (_a = this.viewPositionControls) === null || _a === void 0 ? void 0 : _a.leftBtn) === null || _b === void 0 ? void 0 : _b.removeEvent('click', this.setPositionFunctions.left);
        (_d = (_c = this.viewPositionControls) === null || _c === void 0 ? void 0 : _c.rightBtn) === null || _d === void 0 ? void 0 : _d.removeEvent('click', this.setPositionFunctions.right);
        (_f = (_e = this.viewPositionControls) === null || _e === void 0 ? void 0 : _e.topBtn) === null || _f === void 0 ? void 0 : _f.removeEvent('click', this.setPositionFunctions.top);
        (_h = (_g = this.viewPositionControls) === null || _g === void 0 ? void 0 : _g.bottomBtn) === null || _h === void 0 ? void 0 : _h.removeEvent('click', this.setPositionFunctions.bottom);
        (_k = (_j = this.viewPositionControls) === null || _j === void 0 ? void 0 : _j.frontBtn) === null || _k === void 0 ? void 0 : _k.removeEvent('click', this.setPositionFunctions.front);
        (_m = (_l = this.viewPositionControls) === null || _l === void 0 ? void 0 : _l.backBtn) === null || _m === void 0 ? void 0 : _m.removeEvent('click', this.setPositionFunctions.back);
        (_p = (_o = this.viewPositionControls) === null || _o === void 0 ? void 0 : _o.centerBtn) === null || _p === void 0 ? void 0 : _p.removeEvent('click', this.setPositionFunctions.center);
    }
    setPosition(positionType) {
        PubSub.publish("change-model-view-position" /* CHANGE_MODEL_VIEW_POSITION */, positionType);
    }
}
exports.ViewPosition = ViewPosition;
